import React from "react";
import { QUICK_EQUIP_PRESETS } from "@/data/vipQuickEquipPresets";
import { useI18n } from "@/i18n/I18nProvider";

/**
 * @param {{ onApply: (presetId: string) => void }} props
 */
export default function QuickEquipBar({ onApply }) {
    const { t, l } = useI18n();
    return (
        <div className="vip-sim-quick-equip" aria-label={t("simulator.quick.aria")}>
            <span className="vip-sim-quick-equip__label">{t("simulator.quick.label")}</span>
            <div className="vip-sim-quick-equip__buttons">
                {QUICK_EQUIP_PRESETS.map((preset) => (
                    <button
                        key={preset.id}
                        type="button"
                        className="vip-sim-quick-equip__btn"
                        onClick={() => onApply(preset.id)}
                        title={t("simulator.quick.title", { label: l(preset.label) })}
                    >
                        {l(preset.label)}
                    </button>
                ))}
            </div>
        </div>
    );
}
